import { kzs as _kzs } from "@kaizenplatform/cse-tools";
import { AeonSuggestion } from "./variation/suggestion";
const kzs = window.kzs;

const expScript = (context: _kzs.precedingJsContext): Promise<void> => {
  kzs.console.log(context);
  const Promise = kzs.Promise;

  const isTarget = (url: string): boolean => {
    const kv = new URL(location.href).searchParams.get("_kz_force_display");
    if (kv == "true") {
      // 強制表示対象
      return true;
    }

    const userData = kzs.current.userData[url];
    if (userData == undefined) {
      // 再訪催促の対象ユーザでない
      return false;
    }

    const visited = userData.visited; // minions申し込みページに訪問したか否か
    const completed = userData.completed; // minions申し込みで完了ページまで到達したか否か
    const suggestion = userData.suggestion; // 再訪催促のポップアップを表示した回数
    kzs.console.log(
      `visited: ${visited}, completed: ${completed}, suggestion: ${suggestion}`
    );
    if (visited != "true" || completed != "false" || suggestion != 0) {
      // 再訪催促の対象ではない
      return false;
    }
    return true;
  };

  return Promise.resolve()
    .then(() => {
      const url = "https://www.aeon.co.jp/application/minions/";
      if (!isTarget(url)) {
        return Promise.reject("not a target user.");
      }
    })
    .then(() => {
      window.kzAeonSuggestion = {
        run: () => {
          new AeonSuggestion().run();
        },
      };
    });
};

export default expScript;
